import React, { createContext, useContext, ReactNode } from "react";
import { useSession, User } from "../api/session";

interface AuthContextValue {
  user: User | null;
  admin: User | null;
  isLoading: boolean;
  isAdmin: boolean;
  exitUrl: string; // /system/agentic for admin, /app for user
}

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const { data, isLoading } = useSession();

  const value: AuthContextValue = {
    user: data?.user ?? null,
    admin: data?.admin ?? null,
    isLoading,
    isAdmin: !!data?.admin,
    exitUrl: data?.admin ? "/system/agentic" : "/app",
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
}

export function useCurrentUser(): User | null {
  return useAuth().user;
}

export function useCurrentAdmin(): User | null {
  return useAuth().admin;
}

export function useExitUrl(): string {
  return useAuth().exitUrl;
}
